import React from 'react';
import cx from 'classnames';

import Modal from '~/components/modals/modal';

import modalStyles from '~/components/modals/modal.module.scss';

const SortModal = ({
  onClose,
  isOpen,
  selectedOption,
  onSelect,
  type,
  sortOptions,
}) => {
  const handleClick = (optionName) => {
    const { sortKey, sortDirection } = sortOptions[optionName];
    onSelect(sortKey, sortDirection);
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      className={modalStyles.productSort}
    >
      <h2 className={modalStyles.heading}>Sort by</h2>
      <ul className={modalStyles.optionsList}>
        {sortOptions &&
          Object.keys(sortOptions).map((optionName) => (
            <li key={optionName}>
              <button
                className={cx(modalStyles.button, {
                  [modalStyles.selected]: selectedOption === optionName,
                })}
                onClick={() => handleClick(optionName)}
              >
                {optionName}
                {optionName === selectedOption && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="14"
                    fill="none"
                  >
                    <path
                      d="M6 11.17L1.83 7 .41 8.41 6 14 18 2 16.59.59 6 11.17z"
                      fill="#38996c"
                    />
                  </svg>
                )}
              </button>
            </li>
          ))}
      </ul>
    </Modal>
  );
};

export default SortModal;
